import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

const emailsUrl = "/api/v1/email";

export interface ShareArticleModel extends BaseModel {
    friendsName: string;
    friendsEmailAddress: string;
    yourName: string;
    yourEmailAddress: string;
    yourMessage: string;
    articleImage: string;
    articleDescription: string;
    altText: string;
    articleUrl: string;
}

export interface ShareArticleParameter {
    friendsName: string;
    friendsEmailAddress: string;
    yourName: string;
    yourEmailAddress: string;
    yourMessage: string;
    articleImage: string;
    articleDescription: string;
    altText: string;
    articleUrl: string;
    onSuccess?: () => void;
}

export interface ShareArticleApiParameter extends ApiParameter {
    shareArticleModel: ShareArticleModel;
}

export function shareArticleService(parameter: ShareArticleApiParameter) {
    return post<ShareArticleModel>(`${emailsUrl}/shareArticle`, parameter.shareArticleModel);
}
